import { render, staticRenderFns } from "./AccommodationsLedgerAccounts.vue?vue&type=template&id=5688f4ec&"
import script from "./AccommodationsLedgerAccounts.vue?vue&type=script&lang=js&"
export * from "./AccommodationsLedgerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports